import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';
const getHashFromURL = (url: string, baseURL = window.location.href) => {
    if (!url) return '';
    try {
        return new URL(url, baseURL).hash;
    } catch (e) {
        LoggingHandler().logError('Invalid URL passed to getHashFromURL', {
            searchTerm: 'url-hash-error',
            fileName: 'urlUtils.js',
            additionalData: {
                error: e,
            },
        });
        return '';
    }
};

export { getHashFromURL };
